import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StoryText extends Component {
  constructor(props){
    super(props);
    this.$el = React.createRef();
    this.state = {
      shouldHide: false,
      expanded: true
    };
  }

  componentDidMount(){
    if (!this.state.expanded && this.props.expandable){
      const height = this.$el.current.offsetHeight;
      if (height > this.props.maxHeight){
        this.setState({
          shouldHide: true
        });
      }
    }
  }

  expand(){
    this.setState({
      expanded: true
    });
  }

  render(){
    return (
      <div
        ref={this.$el}
        className={`fe-stories-content ${(this.state.expanded || !this.state.shouldHide) ? 'expanded' : ''}`}
        onClick={this.props.expandable ? this.expand.bind(this) : null}
      >
        {this.props.children}
        <div className="fe-stories-read-more">{this.props.overlayText}</div>
      </div>
    );
  }
}

StoryText.defaultProps = {
  expandable: true,
  maxHeight: 275
};

StoryText.propTypes = {
  children: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  maxHeight: PropTypes.number,
  overlayText: PropTypes.string.isRequired
};

export default StoryText;
